import React from 'react';
import { graphql } from 'gatsby';
import GridSection from 'design-system/src/components/organisms/GridSection';

import { getImage } from '../../utils/media';

export default function GridNavigation2Section({
    items,
    filters,
    ...props
}: any) {
    return (
        <GridSection
            {...props}
            variant="grid-navigation-2"
            items={
                items?.length > 0 &&
                items.map((item: any) => ({
                    ...item,
                    media: getImage(item?.media),
                }))
            }
            filters={
                filters?.length > 0 &&
                filters.map((filter: any) => ({
                    ...filter,
                    items: filter.items.map((item: any) => ({
                        ...item,
                        media: getImage(item?.media),
                    })),
                }))
            }
        />
    );
}

export const query = graphql`
    fragment DatoCmsGridNavigation2Section on DatoCmsGridNavigation2Section {
        title
        titleTag
        text: description
        filters {
            ...DatoCmsFilterBlock
        }
        items {
            ...DatoCmsSolution
        }
    }
`;
